import { setModal } from 'reducers/listReducer'
import { AdvanceFilterModal } from 'components/order/order-list/AdvanceFilterModal'
import { useEffect, useState } from 'react'
import { ARRAY_FILTER, ARRAY_OBJECT_FILTER, INITIAL_FILTER_VALUE } from 'configs/order/configOrder'
import { useFetch } from 'services/useFetch'
import { API_ORDER } from 'services/apiOrder'
import { API_MASTER } from 'services/apiMaster'
import { useDispatch, useSelector } from 'react-redux'

export const AdvanceFilterContainer = ({ queryFilter, onChangeQuery }) => {
    const dispatch = useDispatch()
    const { modal } = useSelector((state) => state.listReducer)
    const { fetching: getPaymentMethodApi } = useFetch(API_MASTER.PAYMENT_METHOD, { withoutGrouping: true })
    const { fetching: getShippingMethodApi } = useFetch(API_MASTER.SHIPPING_METHOD)
    const { fetching: getProductListApi } = useFetch(API_ORDER.SEARCH_PRODUCT)
    const { fetching: getVoucherListApi } = useFetch(API_ORDER.SEARCH_VOUCHER)
    const [filterValue, setFilterValue] = useState(INITIAL_FILTER_VALUE)
    const [filterOptions, setFilterOptions] = useState({
        payment_services: [],
        shipping_aliases: [],
        product_ids: [],
        voucher_ids: [],
    })

    const onSearchList = (type, keyword) => {
        const api = type === 'product_ids' ? getProductListApi : getVoucherListApi
        api({ search: keyword }).then((response) => {
            setFilterOptions({ ...filterOptions, [type]: response.data })
        })
    }

    const onChangeFilter = (filterItem) => {
        setFilterValue({ ...filterValue, [filterItem.name]: filterItem.value })
    }

    const clearFilter = () => {
        setFilterValue(INITIAL_FILTER_VALUE)
    }

    const getQueryAdvanceFilter = (filter) => {
        const queryFilter = { ...filter }
        Object.entries(queryFilter).forEach(([key, item]) => {
            if (ARRAY_OBJECT_FILTER?.includes(key)) {
                const mapData = item.map((i) => JSON.stringify(i))
                queryFilter[key] = mapData?.join('|')
            } else if (ARRAY_FILTER?.includes(key)) {
                queryFilter[key] = item?.join(',')
            }
        })
        return queryFilter
    }

    const getFilterCount = () => {
        const values = { ...queryFilter }
        let count = 0
        Object.entries(values).map(([key, item]) => {
            if ([...ARRAY_FILTER, ...ARRAY_OBJECT_FILTER]?.includes(key)) {
                count += item?.length
            } else if (values[key]) {
                count++
            }
        })
        return count
    }

    const onSubmitFilter = () => {
        let payload = getQueryAdvanceFilter(filterValue)
        onChangeQuery({ ...payload, page: 1, limit: 20 })
        dispatch(setModal({ advanceFilter: false }))
    }

    useEffect(() => {
        if (modal?.advanceFilter) {
            Promise.all([getShippingMethodApi(), getPaymentMethodApi(), getProductListApi(), getVoucherListApi()]).then(
                (response) => {
                    setFilterOptions({
                        shipping_aliases: response[0]?.data,
                        payment_services: response[1].data,
                        product_ids: response[2].data,
                        voucher_ids: response[3].data,
                    })
                },
            )
            setFilterValue({ ...filterValue, ...queryFilter })
        }
    }, [modal?.advanceFilter])

    const props = {
        show: modal?.advanceFilter,
        onHide: () => dispatch(setModal({ advanceFilter: false })),
        filterValue,
        onChangeFilter,
        options: filterOptions,
        onSearchList,
        clearFilter,
        onOpenAdvanceFilter: () => dispatch(setModal({ advanceFilter: true })),
        getFilterCount,
        onSubmitFilter,
    }

    return <AdvanceFilterModal {...props} />
}
